import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import BreadcrumbProp from './breadcrumbProp';
import Breadcrumbs from './Breadcrumbs';
import WhiteBar from './WhiteBar';

/**
 * Page sub header, as defined by metronic
 */
export default function SubHeader({
  title,
  breadcrumbs,
  hasWhiteBar,
  filter,
  wrapperClass,
}) {
  const titleClass = cx('m-subheader__title', {
    'm-subheader__title--separator': breadcrumbs.length > 0,
  });

  return (
    <div className={`m-subheader ${wrapperClass}`}>
      <div className="d-flex align-items-center">
        <div className="mr-auto">
          <h3 className={titleClass}>{title}</h3>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
      </div>
      {hasWhiteBar && <WhiteBar filter={filter} />}
    </div>
  );
}

SubHeader.propTypes = {
  title: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape(BreadcrumbProp.propType)),
  hasWhiteBar: PropTypes.bool,
  filter: PropTypes.string,
  wrapperClass: PropTypes.string,
};

SubHeader.defaultProps = {
  breadcrumbs: [],
  hasWhiteBar: false,
  filter: null,
  wrapperClass: '',
};
